import React, { useState } from "react";
import "./styles.css";
import { Dropdown, Button, MessagePlugin } from "tdesign-react";
import { Icon } from "tdesign-icons-react";
import CategoriesSubMenu from "../CategoriesSubMenu";
import MarcasSubMenu from "../MarcasSubmenu"

interface Iprops {}

const SubHeader = () => {
  const [hoverCategories, setHoverCategories] = useState(false);
  const [hoverMarcas, setHoverMarcas] = useState(false);
  return (
    <div className="subHeader">
      {/*         <Dropdown options={options} onClick={clickHandler}>
      <Button variant="text" suffix={<Icon name="chevron-down" size="16" />}>
        Categorias
      </Button>
    </Dropdown> */}
      <div className="listCategories">
        <p
          onMouseOver={() => setHoverCategories(true)}
          onMouseLeave={() => setHoverCategories(false)}
        >
          Categorias
        </p>
        <p
          onMouseOver={() => setHoverMarcas(true)}
          onMouseLeave={() => setHoverMarcas(false)}
        >
          Marcas
        </p>
        <p>Promociones</p>
        <div className="colorYellow"></div>
        {hoverCategories && <CategoriesSubMenu hoverCategories={hoverCategories} setHoverCategories={setHoverCategories} />}
        {  hoverMarcas && <MarcasSubMenu setHoverMarcas={setHoverMarcas}/>}
      </div>
    </div>
  );
};

export default SubHeader;
